import React, {Component} from 'react';
import {User} from "../../classes/user";
import Wrapper from "../Wrapper";
import {Link} from "react-router-dom";
import axios from "axios";
import {Survey} from "../../classes/survey";
import Paginator from "../components/Paginator";
import Deleter from "../components/Deleter";
import {connect} from "react-redux";

class Surveys extends Component<{ user: User }> {

    state = {
        surveys: []
    }

    page = 1;
    last_page = 0;

    componentDidMount = async () => {
        const response = await axios.get(`surveys/?page=${this.page}`);

        console.log(response);

        this.setState({
            surveys: response.data.data
        })

        this.last_page = response.data.meta.last_page;

    }

    handleDelete = async (id: number) => {
        this.setState({
            surveys: this.state.surveys.filter((s: Survey) => s.id !== id)
        })
    }

    handlePageChange = async (page: number) => {
        this.page = page;

        await this.componentDidMount();
    }

    render() {
        const canEdit = this.props.user.canEdit('survey');

        return (
            <Wrapper>
                {canEdit && <div
                    className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <Link to={'/surveys/create'} className="btn btn-sm btn-outline-secondary">Add</Link>
                    </div>
                </div>}

                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Project ID</th>
                            <th>Country</th>
                            <th>Link</th>
                            <th>Submissions</th>
                            {canEdit && <th>Action</th>}
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.surveys.map(
                            (survey: Survey) => {
                                return (
                                    <tr key={survey.id}>
                                        <td>{survey.id}</td>
                                        <td>{survey.name}</td>
                                        <td>{survey.project_id}</td>
                                        <td>{survey.country}</td>
                                        <td>
                                            {/^https?:\/\//i.test(survey.link) ? (
                                                <a href={survey.link} target="_blank" rel="noopener noreferrer">{survey.link}</a>
                                            ) : survey.link}
                                        </td>
                                        <td>
                                            <Link to={`/submissions?survey=${survey.id}`}>View submissions</Link>
                                        </td>
                                        {canEdit && <td>
                                            <div className="btn-group mr-2">
                                                <Link to={`/surveys/${survey.id}/edit`}
                                                      className="btn btn-sm btn-outline-secondary">Edit</Link>
                                                <Deleter id={survey.id} endpoint={'surveys/'}
                                                         handleDelete={this.handleDelete}/>
                                            </div>
                                        </td>}
                                    </tr>
                                )
                            }
                        )}

                        </tbody>
                    </table>
                </div>

                <Paginator lastPage={this.last_page} handlePageChange={this.handlePageChange}/>

            </Wrapper>
        )
    }
}

export default connect((state: {user: User}) => ({user: state.user}))(Surveys);
